// Encodes special characters. Specifically parentheses that we can have in insurance values.
// router.navigate fails to encode certain characters.
// This functions helps us handle cases like:  Optum/United-EAP (CO).
//
// DRIFT WARNING: this encoding is mirrored byte-for-byte in sitemap-service
// (src/sources/provider-directory/url-builder.ts), whose slug-contract spec is its release
// gate. sitemap-service canonical URLs must match the ones rendered here, so any change to
// this regex must be made in both places or the two surfaces emit divergent URLs.

export const encodeSpecialCharacters = (str: string): string => str.replace(/[!'(),*]/g, (c) => `%${c.charCodeAt(0).toString(16)}`);
